import { useShallow } from 'zustand/react/shallow'
import { useBfnStore } from '@/store/useBfnStore'
import { checkAbruftokenExpired } from '@/features/befehlsnachrichten/utils/abruftoken'
import {
  isArchived,
  isRelevant,
  sortByDate
} from '../utils/archive-entry-classification'

export default function useBfnOverviewEntries(effectiveZugnummer: string) {
  const data = useBfnStore(useShallow((state) => state.data))
  const entries = Object.entries(data)

  const relevantEntries = sortByDate(
    entries.filter(
      ([, entry]) =>
        !checkAbruftokenExpired(entry.abruftoken) &&
        isRelevant(entry, effectiveZugnummer)
    )
  )

  const archivedEntries = sortByDate(
    entries.filter(
      ([, entry]) =>
        !isRelevant(entry, effectiveZugnummer) &&
        isArchived(entry, effectiveZugnummer)
    )
  )

  return { relevantEntries, archivedEntries }
}
